(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["agarscents-product-story"]) return;
  try {
    
function agarscentsNormalizeHeading(value) {
  return (value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

function agarscentsLooksLikeScentProfileHeading(text) {
  var value = agarscentsNormalizeHeading(text);

  return (
    value.includes('scent profile') ||
    value.includes('fragrance profile') ||
    value.includes('fragrance notes') ||
    value.includes('olfactory profile') ||
    value.includes('profil olfactif') ||
    value.includes('notes olfactives') ||
    value.includes('duftprofil') ||
    value.includes('duftnoten') ||
    value.includes('geruchsprofil') ||
    value.includes('perfil olfativo') ||
    value.includes('notas olfativas') ||
    value.includes('perfil de fragancia') ||
    value.includes('profilo olfattivo') ||
    value.includes('note olfattive') ||
    value.includes('profilo della fragranza') ||
    value.includes('향 프로필') ||
    value.includes('향 노트') ||
    value.includes('향조') ||
    value.includes('الملف العطري') ||
    value.includes('الهرم العطري') ||
    value.includes('النوتات العطرية') ||
    value.includes('مكونات العطر') ||
    value.includes('ароматический профиль') ||
    value.includes('профиль аромата') ||
    value.includes('ноты аромата')
  );
}

function agarscentsClassifyNoteLabel(text) {
  var value = agarscentsNormalizeHeading(text);

  if (
    value.includes('top') ||
    value.includes('head') ||
    value.includes('opening') ||
    value.includes('ouverture') ||
    value.includes('tete') ||
    value.includes('kopf') ||
    value.includes('salida') ||
    value.includes('apertura') ||
    value.includes('도입') ||
    value.includes('탑') ||
    value.includes('الافتتاحية') ||
    value.includes('المقدمة') ||
    value.includes('верх')
  ) return 'top';

  if (
    value.includes('heart') ||
    value.includes('middle') ||
    value.includes('coeur') ||
    value.includes('herz') ||
    value.includes('corazon') ||
    value.includes('cuore') ||
    value.includes('미들') ||
    value.includes('하트') ||
    value.includes('القلب') ||
    value.includes('وسط') ||
    value.includes('сердце')
  ) return 'heart';

  if (
    value.includes('base') ||
    value.includes('drydown') ||
    value.includes('fond') ||
    value.includes('basis') ||
    value.includes('fondo') ||
    value.includes('베이스') ||
    value.includes('القاعدة') ||
    value.includes('الأساس') ||
    value.includes('база')
  ) return 'base';

  return '';
}

function agarscentsEnhanceScentProfiles(root) {
  var scope = root || document;
  var descriptions = scope.querySelectorAll('.ags-product-story__description');

  descriptions.forEach(function (description) {
    var headings = description.querySelectorAll('h2, h3, h4');

    headings.forEach(function (heading) {
      if (!agarscentsLooksLikeScentProfileHeading(heading.textContent)) return;

      heading.classList.add('ags-scent-profile-heading');

      var next = heading.nextElementSibling;
      if (!next || (next.tagName !== 'UL' && next.tagName !== 'OL')) return;

      next.classList.add('ags-scent-profile-list');

      var items = next.querySelectorAll(':scope > li');
      items.forEach(function (item) {
        var label = item.querySelector('strong, b');
        var noteType = agarscentsClassifyNoteLabel(label ? label.textContent : item.textContent);
        if (noteType) item.classList.add('ags-note-' + noteType);
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    agarscentsEnhanceScentProfiles(document);
  });
} else {
  agarscentsEnhanceScentProfiles(document);
}

document.addEventListener('shopify:section:load', function (event) {
  agarscentsEnhanceScentProfiles(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
